export default {
    FILE_SIZE_EXCEEDED: 'file size exceeded',
    FILE_EMPTY: 'file empty',
    INVALID_SEARCH_TERM: 'invalid search term',
    INVALID_IP: 'invalid ip',
    NETWORK_ERROR: 'Network Error',
    LIMIT_ERROR: 'limit exceeded'
};
